import { Tabs } from "antd";
import React, { FC, useEffect, useState } from "react";
import { deserialize } from "serializr";
import { MetaModel } from "../../models/CourseModels/SubjectModel/subject.model";
import { Institutes } from "../../models/InstituteModel/institutes.model";
import InstituteService from "../../services/InstituteService/institute.service";
import CommonService from "../../services/CommonService/common.service"
import AppHeader from "../../shared/components/AppHeader";
import EmptyState from "../../shared/components/EmptyState";
import ActivityReport from "./ActivityReport";
import TeacherActivitySummary from "./TeacherReport";
import SalesReport from "./SalesReport";
import LoginActivityReport from "./LoginActivityReport";
import ChapterwiseReport from "./ChapterwiseReport";

// style
import "./reports.scss";


const { TabPane } = Tabs;

const Reports: FC = (props: any) => {
  const [institutes, setInstitutes] = useState<MetaModel[]>([]);

  const fetchInstitutes = () => {
    CommonService.fetchInstitutesMeta(
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setInstitutes(meta);
      },
      () => { },
      () => { }
    );
  };

  useEffect(() => {
    fetchInstitutes();
  }, []);

  return (
    //     <div className='page-view'>
    //     <EmptyState text={'Coming soon...'}/>
    // </div>
    <div className="page-view reports">
      <AppHeader
        headerText="Reports"
        showBreadCrumb={false}
        showFilter={false}
        showSearch={false}
        showButton={false}
      />
      <Tabs defaultActiveKey="1">
        <TabPane key="1" tab="Activity">
          <ActivityReport institutes={institutes} {...props} />
        </TabPane>
        <TabPane key="2" tab="Teacher">
          <TeacherActivitySummary institutes={institutes} {...props} />
        </TabPane>
        <TabPane key="3" tab="Sales Report">
          <SalesReport institutes={institutes} {...props} />
        </TabPane>
        <TabPane key={'4'} tab="Login Activity Report">
          <LoginActivityReport institutes={institutes} {...props} />
        </TabPane>
        <TabPane key={'5'} tab="Chapter wise Report">
          <ChapterwiseReport institutes={institutes} {...props} />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Reports;
